// keyMirror mirrors the keys to values, so that {a: null} comes out as {a: "a"}
import keyMirror from 'keymirror';
import { currentSite } from 'site/currentSite';

export const ActionTypes = keyMirror({
  // ==================================================================
  // Search specific actions
  // ==================================================================

  CHANGE_FILTER_EVENT_TYPE: null,
  CHANGE_FILTER_VENUE_TYPES: null,
  CHANGE_FILTER_PEOPLE: null,
  CHANGE_FILTER_PEOPLE_FILTER: null, // TODO: Come up with a better name #peoplefilter
  CHANGE_FILTER_LOCATION: null,
  CHANGE_FILTER_VENUE_SERVICES: null,
  CHANGE_FILTER_VENUE_TITLE: null,
  CHANGE_FILTER_AVAILABILITY: null,

  CHANGE_SEARCH_SORTING: null,

  TOGGLE_SEARCH_ON_MAP_DRAG: null,
  SEARCH_FROM_MAP_AREA: null,

  FETCH_RESULTS_START: null,
  FETCH_RESULTS_SUCCESS: null,
  FETCH_RESULTS_FAILURE: null,

  SET_INITIAL_RESULTS: null,
  SET_INITIAL_PARAMS: null,

  FOCUS_SEARCH_RESULT: null,

  // ==================================================================
  // Map specific actions
  // ==================================================================

  MAP_AREA_CHANGED: null,

  // ==================================================================
  // Other constants
  // ==================================================================
  CHANGE_PAGE: null
});

export const PayloadSources = keyMirror({
  VIEW_ACTION: null,
  SERVER_ACTION: null
});

const bounds = currentSite().defaultSearchBounds;
export const Defaults = {
  DEFAULT_MAP_BOUNDS: [
    [bounds.south, bounds.west],
    [bounds.north, bounds.east]
  ]
};
